export class OrderWrongDeliveryStatus extends Error {
  constructor() {
    super('Wrong Delivery Status');
  }
}
